<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ ownersCo?.length || 0 }} copropriétaire(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addOwnerCo()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Code</th>
          <th>Nom complet</th>
          <th>Type</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th>Millièmes</th>
          <th>Solde</th>
          <th>État</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of ownersCo">
          <td>{{ item?.code }}</td>
          <td>{{ item?.nomComplet }}</td>
          <td>
            <span class="badge" [ngClass]="item?.type === 'PERSONNE_PHYSIQUE' ? 'badge-info' : 'badge-warning'">
              {{ item?.type === 'PERSONNE_PHYSIQUE' ? 'Personne physique' : 'Personne morale' }}
            </span>
          </td>
          <td>{{ item?.email }}</td>
          <td>{{ item?.telephone }}</td>
          <td class="text-right">{{ item?.totalMilliemes }}</td>
          <td class="text-right" [ngClass]="item?.solde >= 0 ? 'text-success' : 'text-danger'">
            {{ item?.solde | number:'1.0-0' }} FCFA
          </td>
          <td>
            <span class="badge" [ngClass]="item?.etat === 'ACTIF' ? 'badge-success' : 'badge-secondary'">
              {{ item?.etat }}
            </span>
          </td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-info btn-sm mr-1" title="Voir" (click)="showOwnerCo(item)">
              <i class="feather icon-eye"></i>
            </button>
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editOwnerCo(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button *ngIf="item?.isDelete" class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteOwnerCo(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
